import {
  Avatar,
  Button,
  Col,
  Drawer,
  Dropdown,
  Flex,
  Menu,
  Row,
  Space,
  Tag,
  Typography,
  usePaypingContext,
} from "@payping/web-components";
import { Branches, Close, FeatherLeft, PhRUser, Poweroff, QuestionCircleOutlined, Rocket } from "@payping/icons";
import { useAppTranslation } from "@/utils/useAppTranslation";
import {
  changelogMenuDropdownId,
  helpMenuDropdownId,
  logoutMenuDropdownId,
  navProfileId,
  referralMenuDropdownId,
} from "@/assets/googleTrackIds";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";
import { useAppSelector } from "@/utils/redux";
import { ensureString } from "@payping/utilities-shared/string";
import { overviewTourIds } from "@/assets/tourIds";
import { useState } from "react";
import { URLS } from "@payping/utilities-shared/consts";
import { useImmerAtom } from "jotai-immer";
import { coreAtom } from "@/core/state/root";

export const UserProfile = () => {
  const [isMobileProfileDrawerOpen, setIsMobileProfileDrawerOpen] = useState(false);
  const { home } = DashboardRoutes;
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const personalInfo = useAppSelector((state) => state.user.personalInfo);
  const [, setCoreState] = useImmerAtom(coreAtom);

  const { pathname } = useLocation();
  const { breakpoints } = usePaypingContext();
  const { lg } = breakpoints;
  const fullName = ensureString({
    text:
      personalInfo?.businessName ||
      `${ensureString({
        text: personalInfo?.firstName ?? "",
        fallbackValue: "-",
      })} ${ensureString({
        text: personalInfo?.lastName ?? "",
        fallbackValue: "-",
      })}`,
    fallbackValue: "-",
  });

  const mobileContent = (
    <>
      <Button
        type={"text"}
        onClick={() => setIsMobileProfileDrawerOpen((prev) => !prev)}
        data-tourId={overviewTourIds.profileAnchor}
        data-google-track={navProfileId}
        icon={<PhRUser width={20} height={20} />}
      />
      <Drawer
        open={isMobileProfileDrawerOpen}
        placement={"top"}
        size={"100%"}
        title={t("profile.title")}
        closeIcon={false}
        // because MainNavMobile z-index is 2004
        zIndex={2005}
        data-tourId={overviewTourIds.profileDropdown}
        extra={
          <Button
            type={"text"}
            icon={<Close width={14} height={14} />}
            onClick={() => {
              setIsMobileProfileDrawerOpen(false);
            }}
          />
        }
      >
        <Row gutter={[0, 48]} className={"tw:w-full"}>
          {/* < تایتل آواتار و نام کامل کاربری> */}
          <Col span={24}>
            <Flex vertical gap={"28px"} justify={"center"} align={"center"}>
              <Avatar size={72} className="background--gray100" src={<PhRUser width={"45px"} />} />
              <Flex vertical justify={"center"} align={"center"}>
                <Typography.Title level={5}>{fullName}</Typography.Title>
                <Tag className={"tw:flex tw:items-center"}>
                  <Typography.Text strong>{personalInfo?.id}</Typography.Text>
                </Tag>
              </Flex>
            </Flex>
          </Col>

          {/* < منو گزینه ها > */}
          <Col span={24}>
            <Menu
              triggerSubMenuAction={"click"}
              style={{
                borderLeft: "none", // Remove border it's causing the vertical line
              }}
            >
              {/* < اطلاعات کاربری > */}
              <Menu.Item key={"1"}>
                <Link
                  onClick={() => {
                    setCoreState((draft) => {
                      // eslint-disable-next-line no-param-reassign
                      draft.firstUrlToSettingsAndProfile = pathname;
                    });
                    setIsMobileProfileDrawerOpen(false);
                  }}
                  to={DashboardRoutes.profile.root.url}
                >
                  <Space className={"tw:flex tw:justify-between"}>
                    <Space>
                      <PhRUser width={"14px"} />
                      <Typography.Text>{` ${t("profileMenu.profile")}`}</Typography.Text>
                    </Space>
                    <FeatherLeft width={"16px"} />
                  </Space>
                </Link>
              </Menu.Item>
              <Menu.Item
                data-google-track={referralMenuDropdownId}
                key={"2"}
                onClick={() => {
                  navigate(DashboardRoutes.user.referral.url);
                  setIsMobileProfileDrawerOpen(false);
                }}
              >
                <Space className={"tw:flex tw:justify-between"}>
                  <Space>
                    <Rocket width={"14px"} />
                    <Typography.Text>{` ${t("profileMenu.earnMoney")}`}</Typography.Text>
                  </Space>
                  <FeatherLeft width={"16px"} />
                </Space>
              </Menu.Item>
              <Menu.Item
                data-google-track={referralMenuDropdownId}
                key={"3"}
                onClick={() => {
                  navigate(home.changeLog.url);
                  setIsMobileProfileDrawerOpen(false);
                }}
              >
                <Space className={"tw:flex tw:justify-between"}>
                  <Space>
                    <Branches width={"14px"} />
                    <Typography.Text>{t("mainNav.userProfile.lastChange")}</Typography.Text>
                    <div className="ltr">
                      <Typography.Text className="en-font" type={"secondary"}>
                        {process.env.REACT_APP_VERSION}
                      </Typography.Text>
                    </div>
                  </Space>
                  <FeatherLeft width={"16px"} />
                </Space>
              </Menu.Item>
              <Menu.Item
                data-google-track={referralMenuDropdownId}
                key={"4"}
                onClick={() => {
                  window.open(URLS.HELP_URL, "_blank");
                  setIsMobileProfileDrawerOpen(false);
                }}
              >
                <Space className={"tw:flex tw:justify-between"}>
                  <Space>
                    <QuestionCircleOutlined width={"14px"} />
                    <Typography.Text>{t("guide")}</Typography.Text>
                  </Space>
                  <FeatherLeft width={"16px"} />
                </Space>
              </Menu.Item>
              <Menu.Item
                key={"5"}
                onClick={() => {
                  navigate("/logout");
                  setIsMobileProfileDrawerOpen(false);
                }}
              >
                <Space className={"tw:flex tw:justify-between"}>
                  <Space>
                    <Poweroff width={"14px"} />
                    <Typography.Text>{` ${t("profileMenu.exit")}`}</Typography.Text>
                  </Space>
                  <FeatherLeft width={"16px"} />
                </Space>
              </Menu.Item>
            </Menu>
          </Col>
        </Row>
      </Drawer>
    </>
  );

  const desktopContent = (
    <Dropdown
      zIndex={999}
      trigger={["click"]}
      classNames={{ root: "tw:w-[340px]!" }}
      data-google-track={navProfileId}
      placement={"bottomRight"}
      menu={{
        // @ts-expect-error missing prop
        "data-tourId": overviewTourIds.profileDropdown,
        items: [
          {
            key: "0",
            disabled: true,
            className: "tw:cursor-default!",
            label: (
              <>
                <Space>
                  <Avatar
                    size={lg ? "default" : "small"}
                    src={personalInfo?.profilePicture || <PhRUser className="tw:p-1!" width={"22px"} color={"white"} />}
                  />
                  <Typography.Text>{fullName}</Typography.Text>
                </Space>
                {!lg ? (
                  <Link to={DashboardRoutes.logout.url}>
                    <Button icon={<Poweroff width={14} height={14} />}>{t("profileMenu.exit")}</Button>
                  </Link>
                ) : null}
              </>
            ),
          },
          {
            type: "divider",
          },
          {
            key: "1",
            icon: <PhRUser />,
            label: (
              <Link
                onClick={() => {
                  setCoreState((draft) => {
                    // eslint-disable-next-line no-param-reassign
                    draft.firstUrlToSettingsAndProfile = pathname;
                  });
                }}
                to={DashboardRoutes.profile.root.url}
              >
                <Typography.Text>{` ${t("profileMenu.profile")}`}</Typography.Text>
              </Link>
            ),
          },
          {
            key: "2",
            icon: <Rocket />,
            label: (
              <Link to={DashboardRoutes.user.referral.url}>
                <Typography.Text>{` ${t("profileMenu.earnMoney")}`}</Typography.Text>
              </Link>
            ),
            "data-google-track": referralMenuDropdownId,
          },
          {
            key: "3",
            icon: <Branches />,
            label: (
              <Link to={home.changeLog.url}>
                <Flex justify={"space-between"} align={"center"}>
                  <Typography.Text>{t("mainNav.userProfile.lastChange")}</Typography.Text>
                  <Typography.Text className="ltr en-font" type={"secondary"}>
                    {process.env.REACT_APP_VERSION}
                  </Typography.Text>
                </Flex>
              </Link>
            ),
            "data-google-track": changelogMenuDropdownId,
          },
          {
            key: "4",
            icon: <QuestionCircleOutlined />,
            label: (
              <a href={URLS.HELP_URL} target={"_blank"} rel={"noreferrer"}>
                <Typography.Text>{t("guide")}</Typography.Text>
              </a>
            ),
            "data-google-track": helpMenuDropdownId,
          },
          ...(lg
            ? [
                {
                  type: "divider",
                } as const,
                {
                  key: "7",
                  icon: <Poweroff />,
                  label: (
                    <Link to={DashboardRoutes.logout.url}>
                      <Typography.Text>{` ${t("profileMenu.exit")}`}</Typography.Text>
                    </Link>
                  ),
                  "data-google-track": logoutMenuDropdownId,
                },
              ]
            : []),
        ],
      }}
    >
      <Button
        type={"text"}
        data-google-track={"profile-dropdown"}
        data-tourId={overviewTourIds.profileAnchor}
        icon={<PhRUser width={20} />}
      />
    </Dropdown>
  );

  return lg ? desktopContent : mobileContent;
};
